// Apolo IDE — FileCard (Code chat redesign v2 · Codex-rich).
//
// "Arquivo apresentado no chat" — o card que o Pedro curte no mockup
// _mockups/code-chat-v2 (.filecard): ícone de documento azul com glow, nome +
// "Documento · {EXT}", e um expander pra ver o conteúdo. É o par de leitura do
// DiffCard (que é o par de escrita): read_file vira ESTE card, write_file vira o
// DiffCard verde.
//
//   • Header (.rx-filecard-row): ícone FileText azul (.rx-ic) + nome + meta.
//   • "Ver conteúdo" expande o FilePreview (variant read) — nada se perde vs o
//     ToolCallBlock antigo; só fica mais bonito e colapsado por padrão.
//   • Sem conteúdo (read vazio) → card estático, sem expander.

import { useState } from 'react';
import { FileText, ChevronRight, ChevronDown } from 'lucide-react';
import FilePreview from './FilePreview.jsx';
import './redesign.css';

function basename(path) {
  const str = String(path ?? '').replace(/\\/g, '/');
  return str.split('/').pop() || str;
}

function extLabel(path) {
  const name = basename(path);
  const dot = name.lastIndexOf('.');
  return dot > 0 ? name.slice(dot + 1).toUpperCase() : 'TXT';
}

export default function FileCard({ path, content }) {
  const [open, setOpen] = useState(false);
  const name = basename(path);
  const hasContent =
    typeof content === 'string' && content.trim().length > 0 && content !== '(sem saída)';

  return (
    <div className="rx-filecard-box my-1">
      <button
        type="button"
        className="rx-filecard-row"
        onClick={() => hasContent && setOpen((v) => !v)}
        aria-expanded={hasContent ? open : undefined}
        aria-label={`Arquivo ${name}`}
      >
        <span className="rx-ic">
          <FileText size={18} aria-hidden="true" />
        </span>
        <div className="rx-fc-t">
          <div className="rx-n" title={path}>{name}</div>
          <div className="rx-m">Documento · {extLabel(path)}</div>
        </div>
        {hasContent && (
          <span className="rx-fc-act">
            {open ? 'Ocultar' : 'Ver conteúdo'}
            {open ? (
              <ChevronDown size={13} aria-hidden="true" />
            ) : (
              <ChevronRight size={13} aria-hidden="true" />
            )}
          </span>
        )}
      </button>
      {open && hasContent && (
        <div className="rx-filebody">
          <FilePreview path={path} content={content} variant="read" />
        </div>
      )}
    </div>
  );
}
